<template>
	<div class="network">
		<div class="intro">
			<h2>Compound-Target Relationship</h2>
			<!-- <p>A visual overview of the relationship between targets. Input a master node by CHEMBL_ID and
				then click the submit button to
				generate a network. Click on a node to explore the details.</p> -->
		</div>

		<el-tabs v-model="activeName" @tab-click="tabClick">
			<el-tab-pane label="Relationship" name="tab1">
				<el-form :inline="true" class="demo-form-inline">
					<div style="margin-bottom: 20px;color: #606266;font-size: 18px;">
						Predict the relationship of the given compound and target
					</div>
					<el-form-item label="Please select">

					</el-form-item>


					<el-form-item label="">
						<el-input placeholder="Compound" v-model="Compound_Chembl_ID" :disabled="true">
							<el-button slot="append" @click="browseClick('Compound')">Browse</el-button>
						</el-input>

					</el-form-item>

					<el-form-item label="">
						<el-input placeholder="Target" v-model="Target_Chembl_ID" :disabled="true">
							<el-button slot="append" @click="browseClick('Target')">Browse</el-button>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit" :disabled="SubmitDisabled">Submit</el-button>
					</el-form-item>
				</el-form>
			</el-tab-pane>
			<el-tab-pane label="Protential Targets" name="tab2">
				<el-form :inline="true" class="demo-form-inline">
					<div style="margin-bottom: 20px;color: #606266;font-size: 18px;">
						Find the potential targets for the given compound(with the predicted score >0.9)
					</div>
					<el-form-item label="Please select">

					</el-form-item>


					<el-form-item label="">
						<el-input placeholder="Compound" v-model="Compound_Chembl_ID" :disabled="true">
							<el-button slot="append" @click="browseClick('Compound')">Browse</el-button>
						</el-input>

					</el-form-item>


					<el-form-item>
						<el-button type="primary" @click="onSubmit" :disabled="SubmitDisabled">Submit</el-button>
					</el-form-item>
				</el-form>
			</el-tab-pane>

		</el-tabs>
		<div class="el-row mainContent" v-if="result == 0">
			<el-card class="box-card" style="margin-right: 0;">
				<div style="text-align: center;align-items: center;color:gray;margin-top: 30px;">
					<div>
						<img src="../assets/no_record_pic.png" alt="" width="250" height="140" />
					</div>
					<p :style="{'marginTop': '23px'}">Empty</p>
				</div>

			</el-card>
		</div>

		<div class="el-row mainContent" v-if="result>0">

			<div class="el-col el-col-8">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>Picture of Structure</span>
					</div>
					<el-image style="width: 250px; height: 250px;" fit="fill" :src="ComInfo.Structure"></el-image>
					<!-- <div class="btn-warp">
						<el-button type="primary" @click="downloadFile">Download</el-button>
					</div> -->
				</el-card>
			</div>
			<div class="el-col el-col-8">
				<el-card class="box-card">
					<div slot="header" class="clearfix">
						<span>Compound information</span>
					</div>
					<!-- <div class="text-item">
				    (Molecular Weight, Chemical Formula, logP, # HB acc, # HB don, #
				    RotB )
				  </div> -->
					<div class="text-item">
						<span class="name">Name:</span>
						<span class="val" v-text="ComInfo.Name"></span>
					</div>
					<div class="text-item">
						<span class="name">ChEMBL_ID:</span>
						<span class="val" v-text="ComInfo.ChEMBL_ID"></span>
					</div>
					<div class="text-item">
						<span class="name">Inflam_id:</span>
						<span class="val" v-text="ComInfo.Inflam_id"></span>
					</div>


				</el-card>
			</div>
			<div class="el-col el-col-8" v-if="activeName == 'tab1'">
				<el-card class="box-card" style="margin-right: 0;">
					<div slot="header" class="clearfix">
						<span>Target information</span>
					</div>
					<!-- <div class="text-item">
				    (Molecular Weight, Chemical Formula, logP, # HB acc, # HB don, #
				    RotB )
				  </div> -->
					<div class="text-item">
						<span class="name">Name:</span>
						<span class="val" v-text="TarInfo.Name"></span>
					</div>
					<div class="text-item">
						<span class="name">Synonyms:</span>
						<span class="val" v-text="TarInfo.Synonyms"></span>
					</div>
					<div class="text-item">
						<span class="name">Target_ChEMBL_ID:</span>
						<span class="val" v-text="TarInfo.Target_ChEMBL_ID"></span>
					</div>


				</el-card>
			</div>

		</div>
		<div class="el-row mainContent" v-if="result>0 && activeName == 'tab1'">

			<el-card class="box-card" style="min-height: 200px;height: 200px;margin-right: 0;">
				<div slot="header" class="clearfix">
					<span style="font-weight: bold;color:red">Relationship_Predict:</span>
					<span style="margin-left: 20px;font-weight: bold;color:red"
						v-text="RelInfo==-1?'Not Found':RelInfo"></span>
				</div>
				<!-- <div class="text-item">
			    (Molecular Weight, Chemical Formula, logP, # HB acc, # HB don, #
			    RotB )
			  </div> -->

				<div class="text-item">
					Relationship_Predict = 0: The compound (< 50 μM) CANNOT directly modulate the protein </div>
						<div class="text-item">
							Relationship_Predict = 1: The compound (< 50 μM) directly modulates the protein </div>
			</el-card>

		</div>
		<div class="el-row mainContent" v-if="result>0 && activeName == 'tab2'">
		
			<el-card class="box-card" style="height: auto;margin-right: 0;">
				<div slot="header" class="clearfix">
					<span style="font-weight: bold;color:red">Targets Information:</span>
					
				</div>
				<el-table :data="ranklist" v-loading="rank_loading">
					<el-table-column
					        label="Rank"
					        type="index"
					        width="100px"
					        align="center">
					    <template scope="scope">
					        <span>{{(rank_page - 1) * rank_size + scope.$index + 1}}</span>
					    </template>
					</el-table-column>
					<el-table-column prop="Target_ChEMBL_ID" label="Target_ChEMBL_ID" width="200px">
					</el-table-column>
					<el-table-column prop="Name" label="Name"> </el-table-column>
					<el-table-column prop="Relationship_predict" label="Relationship_predict"> </el-table-column>
					<el-table-column fixed="right" label="Detail">
					  <template slot-scope="scope">
					    <el-button @click="toDetail(scope.row.id)" type="text" size="small" style="font-size: 18px;">Detail</el-button>
					  </template>
					</el-table-column>
				
				</el-table>
				<el-pagination align="left" @current-change="rankPageChange" :current-page="rank_page" :page-size="10" background
					layout="total, prev, pager, next, jumper" :total="rank_total" />
				
				
			</el-card>
			
		</div>
		<el-dialog :title="'Please Click to Select a ' +SelectType+' Node'" :close-on-click-modal="false"
			:visible.sync="dialogTableVisible">
			<div class="el-col el-col-6"
				style="padding-left: 10px; padding-right: 10px; position: absolute; right: 100px; top: 12px;">
				<div class="search el-input">
					<!----><input type="text" autocomplete="off" placeholder="Search" icon="search"
						class="el-input__inner" v-model="key" @input="keychange">
					<!---->
					<!---->
					<!---->
					<!---->
				</div>
			</div>
			<el-table :data="showData"  v-loading="select_loading">
				<el-table-column prop="Inflam_id" label="ID" width="200px">
					<template slot-scope="scope">
						<el-link type="primary" @click="selectChembl(scope.row.ChEMBL_ID)">{{scope.row.ChEMBL_ID}}
						</el-link>
					</template>
				</el-table-column width="200px">
				<el-table-column prop="Name" label="Name"> </el-table-column>

			</el-table>
			<el-pagination align="right" @current-change="currentChange" :current-page="page" :page-size="10" background
				layout="total, prev, pager, next, jumper" :total="total" />

		</el-dialog>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				tableData: [],
				formInline: {
					user: '',
					region: ''
				},

				typer: false,
				network: [],
				BrowseDisabled: true,
				SubmitDisabled: true,
				SelectType: '',
				dialogTableVisible: false,
				showData: [],
				key: '',
				page: 1,
				size: 10,
				loading: false,
				Compound_Chembl_ID: '',
				Target_Chembl_ID: '',
				total: 0,
				result: 0,
				ComInfo: [],
				TarInfo: [],
				RelInfo: 0,
				activeName: 'tab1',
				ranklist:[],
				rank_total:0,
				rank_page:1,
				rank_size:10,
				rank_loading:false,
				select_loading:false,
			}
		},
		methods: {
			queryRank(){
				let _this= this
				if(_this.activeName == 'tab2'){
					
					_this.rank_loading = true
					var form = {
						comid: _this.Compound_Chembl_ID,
						page: _this.rank_page,
						size: _this.rank_size
					};
					_this.$http({
						url: "/api/rdkit/queryProtentialTargetsRank",
						params: form,
						method: "get",
					}).then((res) => {
					
						_this.ranklist = res.data.data.list
						_this.rank_total = res.data.data.count
						if (!_this.showData.length) {
							_this.$message.warning("No Target matched");
						}
						_this.rank_loading = false;
					});
				}
			},
			toDetail(id) {
			  const { origin, pathname } = window.location;
			  window.open(`${origin}${pathname}#/main/searchBytar/detail_t?id=${id}`);
			//   window.open(`${origin}${pathname}#/main/searchBytar/detail_t?id=${id}`);
			},
			tabClick(){
				this.result = 0
				this.ComInfo = []
				this.TarInfo = []
				this.RelInfo = 0
				//this.Compound_Chembl_ID = ''
				this.Target_Chembl_ID = ''
				
				if(this.Compound_Chembl_ID != '' && this.activeName == 'tab2'){
					this.SubmitDisabled = false
				}
				//console.log(this.activeName);
			},
			keychange() {
				this.page = 1;
				this.queryChembl()
			},
			currentChange(num) {
				this.page = num;
				this.queryChembl()
			},
			rankPageChange(num) {
				this.rank_page = num;
				this.queryRank()
			},
			
			
			selectChembl(id) {
				if (this.SelectType == 'Compound') {
					this.Compound_Chembl_ID = id
				} else {
					this.Target_Chembl_ID = id
				}
				
				//如果切换选项卡 按照不同选项卡显示不同的搜索条件
				if(this.activeName == 'tab1'){
					if (this.Compound_Chembl_ID != '' && this.Target_Chembl_ID != '') {
						this.SubmitDisabled = false
					}
				}else{
					if (this.Compound_Chembl_ID != '') {
						this.SubmitDisabled = false
					}
				}
				

				this.dialogTableVisible = false
			},

			browseClick(SelectType) {
				let _this = this
				_this.loading = true;
				_this.dialogTableVisible = true
				
				_this.page = 1
				_this.key = ''
				_this.SelectType = SelectType
				_this.queryChembl()
			},
			queryChembl() {
				let _this = this
				var form = {
					key: _this.key,
					page: _this.page,
					size: _this.size,
					type: _this.SelectType
				};
				_this.select_loading = true
				_this.$http({
					url: "/api/rdkit/queryChemblbyRela",
					params: form,
					method: "get",
				}).then((res) => {

					_this.showData = res.data.data.list
					_this.total = res.data.data.count
					if (!_this.showData.length) {
						_this.$message.warning("No Target matched");
					}
					_this.select_loading = false;
				});
			},
			getNetWorkData() {
				
			},
			onSubmit() {
				let _this = this
				var form = {
					comid: _this.Compound_Chembl_ID,
					tarid: _this.Target_Chembl_ID,
				};
				
				
				if (_this.Compound_Chembl_ID == '') {
					_this.$message.warning("SELECT Compound_Chembl_ID");
					return;
				}
				if(this.activeName == 'tab1'){
					if (_this.Target_Chembl_ID == '') {
						_this.$message.warning("SELECT Target_Chembl_ID");
						return;
					}
					
					form = {
						comid: _this.Compound_Chembl_ID,
						tarid: _this.Target_Chembl_ID,
						type : 1
					};
					
					
				}else{
					form = {
						comid: _this.Compound_Chembl_ID,
						type : 2
					};
					_this.queryRank()
				}
				
				

				const loading = _this.$loading({
					lock: true,
					text: 'Loading',
					spinner: 'el-icon-loading',
					background: 'rgba(255, 255, 255, 0.7)'
				});
				_this.$http({
					url: "/api/rdkit/queryRelationship",
					params: form,
					method: "get",
				}).then((res) => {
					loading.close();
					_this.result = 1
					if (res.data.code == "000000") {
						_this.ComInfo = res.data.data.ComInfo
						_this.TarInfo = res.data.data.TarInfo
						_this.RelInfo = res.data.data.RelInfo

					} else {
						_this.$message.warning("No data");
						return;
					}


				});
			},

			ClickSwitchState(e) {
				if (e == '2') {
					this.network.addEdgeMode();
				}
				this.typer = this.typer == e ? false : e;
			},
			processUUID() {
				const urid = 'yxx-xyx-xxy-xxxx'.replace(/[xy]/g, function(a) {
					const b = Math.random() * 13 | 0,
						c = a == 'x' ? b : (b & 0x3 | 0x8);
					return c.toString(16);
				})
				return urid;
			},


		},
		mounted() {

		}
	}
</script>
<style>
	div.vis-configuration.vis-config-item {
		width: 410px !important;
	}
	.el-tabs__item{
		font-size: 18px !important;	
		font-weight: bold !important;
	}
	.cell{
		font-size: 18px !important;
	}
</style>
<style scoped>
	
	.network {
		padding: 0 50px;
		margin: 0 auto;
		font-size: 20px;
	}

	.intro {
		margin: 0 0 20px 0;
	}

	.intro h2 {
		margin-bottom: 10px;
		border-bottom: 2px solid rgb(245, 166, 20);
		text-align: center;
		line-height: 60px;
		font-size: 30px;
		color: #409EFF;
	}

	.intro p {
		padding: 10px 20px;
		margin: 0 0 10px 0;
		background: #F5F7F9;
		border-radius: 4px;
	}

	.mainContent {
		overflow: hidden;
	}

	.mainContent .nodes {
		float: left;
		width: 100%;
		max-height: 600px;
		overflow-y: scroll;
		border: 1px solid #d3d3d3;
	}

	.mainContent .legend {
		float: right;
		width: 100%;
		height: 600px;

		border: 1px solid #d3d3d3;
	}

	#legend1 {
		position: absolute;
		width: 15%;
	}

	.legend2 {
		background: #fff;
		width: 171px;
		border: .5px solid #eee;
		margin-left: 12px;
		margin-top: 11px;
		padding-left: 0;
		font-size: 100% !important;
	}

	.lili {
		list-style: none;
		height: 32px;
	}

	.lili div {
		margin-left: 10px;
		margin-right: 5px;
		width: 20px;
		height: 20px;
		vertical-align: middle;
		border-radius: 50%;
		display: inline-block;
	}

	.box-card {
		height: 400px;
		margin-bottom: 10px;
		margin-right: 50px;
	}

	.text-item {
		display: flex;
		margin-bottom: 5px;
		/* justify-content: space-between; */
	}

	.name {
		font-weight: bold;
		margin-right: 80px;
		width: 100px;
		/* text-align: right; */
	}

	.val {
		word-break: break-all;
		flex: 1;
		text-align: left;
		/* display: block; */
		/* padding-left: 150px; */
	}

	.val1 {
		word-break: break-all;
		flex: 1;
		text-align: right;
		/* display: block; */
		/* padding-left: 150px; */
	}
</style>
